import { Component, OnInit } from '@angular/core';
import { CompetitionService } from '../../services/competition/competition.service';
import { Router } from '@angular/router';
import { ConfirmationService, DataTable, Message, SelectItem } from 'primeng/primeng';
import { LazyLoadEvent } from '../../models/DataTables/lazyLoadEvent';
import { Competition } from '../../models/inModels/Competition';
import { NotificationContentType } from '../../models/inModels/MessageModel';

@Component({
  selector: 'app-competitions',
  templateUrl: './competitions.component.html',
  styleUrls: ['./competitions.component.css']
})
export class CompetitionsComponent implements OnInit {
  items: Competition[];
    rows: SelectItem[];
    selectedRows: number;
    filteredRecords: number;
    rowEvent: LazyLoadEvent;
    loading: boolean;
    totalRecords: number;
    error: Message[];
    contentId: number;
    contentType: NotificationContentType;
    sendAllDialog = false;
    displayDialog: boolean = false;
    selectedBook: Competition;
  constructor(
        private service: CompetitionService,
        private router: Router,
        private confirmationService: ConfirmationService
  ) {
    this.loading = true;
		this.rows = [];
		this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;

   }

  ngOnInit() {
  }

  changeRows(event): void {
		this.load(this.rowEvent);
	}

  reset(dt: DataTable, gb: HTMLInputElement) {
      gb.value = '';
      dt.reset();
    }

  load(event: LazyLoadEvent): void {
        this.loading = true;
        event.rows = this.selectedRows;
        this.rowEvent = event;
        this.service.search(event).then(
          dataPager => {
            this.items = dataPager.Data;
            this.filteredRecords = dataPager.FilteredRecords;
            this.totalRecords = dataPager.TotalRecords;
            this.loading = false;
          },
          error => {
            this.loading = false;
            this.items = [];
            this.totalRecords = 0;
            this.filteredRecords = 0;
            this.error = [];
            this.error.push({ severity: 'error', summary: 'Error', detail: error });
          }
        );
      }

    delete(event: Competition) {
      console.log(event);
      this.confirmationService.confirm({
        message: `Are you sure you want to delete ${event.Name}?`,
        header: 'Confirmation',
        icon: 'fa fa-trash-o',
        accept: () => {
          this.loading = true;
          this.service.delete(event.Id).then(
            result => {
              this.loading = false;
              this.load(this.rowEvent);
            },
            error => {
              this.loading = false;
              this.error = [];
              this.error.push({ severity: 'error', summary: 'Error', detail: error });
            });
        }
      });
    }

    edit(item: Competition) {
      this.router.navigate(['competitions/edit', item.Id]);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/competitions/competitions.component.ts